<script lang="ts">
import { getContext, type Snippet } from 'svelte'

import { isMobileDevice } from '@/modules/device'
import {
	contentListItemKey,
	contentMessageAttachmentKey,
	type WritableMessageAttachmentContext,
	type WritableMessageContext,
} from '@/modules/messages'

type Props = {
	children?: Snippet
}

let { children }: Props = $props()

let messageContext = $derived(getContext<WritableMessageContext>(contentListItemKey))
let {
	group: { variant, align },
	neighbors: { hasTop, hasBottom },
} = $derived($messageContext)

let attachmentContext = $derived(getContext<WritableMessageAttachmentContext>(contentMessageAttachmentKey))

let hasTopNeighbor = $derived(attachmentContext ? $attachmentContext.neighbors.hasTop : hasTop)
let hasBottomNeighbor = $derived(attachmentContext ? $attachmentContext.neighbors.hasBottom : hasBottom)
</script>

<div
	class={[
		'message-content px-4 py-2.5 text-base',
		!$isMobileDevice && 'text-sm',
		variant.isPrimary && 'bg-primary-gradient-button text-primary-content',
		variant.isSecondary && 'bg-slate-100 text-slate-800',
		align.isLeft && 'message-content-left',
		align.isLeft && !hasTopNeighbor && 'message-content-left-first',
		align.isLeft && !hasBottomNeighbor && 'message-content-left-last',
		align.isRight && 'message-content-right',
		align.isRight && !hasTopNeighbor && 'message-content-right-first',
		align.isRight && !hasBottomNeighbor && 'message-content-right-last',
	]}
>
	{@render children?.()}
</div>

<style lang="postcss">
.message-content {
	overflow-wrap: break-word;
	word-break: break-word;
	white-space: pre-wrap;
}

/** Message content left */
.message-content-left {
	@apply rounded-r-3xl rounded-l;
}

.message-content-left-first {
	@apply rounded-lt-3xl;
}

.message-content-left-last {
	@apply rounded-lb-3xl;
}

/** Message content right */
.message-content-right {
	@apply rounded-l-3xl rounded-r;
}

.message-content-right-first {
	@apply rounded-rt-3xl;
}

.message-content-right-last {
	@apply rounded-rb-3xl;
}
</style>
